import http from 'hub-http/clients/apiClient';
import { readEarlyRequest } from 'EmailData/utils/earlyRequest';
const URI_MIGRATION_STATUS = 'hub-migration/v1/status';
export default function portalMigrationStatus() {
  return readEarlyRequest({
    key: 'portal-migration-status',
    fetchCallback: () => http.get(URI_MIGRATION_STATUS)
  });
}